import { Create } from "@/features/Create/Create";

export default function CreateView() {
  return <Create />;
}
